import React from "react";
import ArticlePreview from "../../Shared/ContentLibrary/Preview/ArticlePreview";
import libraryService from "../../services/contentLibraryService";
import MPSBarLoader from "../../components/MPSBarLoader";
import MYPPrivacyPolicy from "./MYPPrivacyPolicy";

export default class PrivacyPolicy extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setState({ loading: true });
    if (!this.props.privacyPolicyLibrary) {
      return;
    }
    libraryService
      .loadLibraryItemForSignup(this.props.privacyPolicyLibrary)
      .then(response => {
        this.setState({ privacyPolicy: response, loading: false });
      })
      .catch(e => this.setState({ loading: false }));
  }

  render() {
    let { privacyPolicyLibrary } = this.props;

    if (!privacyPolicyLibrary) {
      return <MYPPrivacyPolicy />;
    }

    let { loading, privacyPolicy } = this.state;
    if (loading) {
      return (
        <div style={{ margin: "100px auto", width: 100 }}>
          <MPSBarLoader />
        </div>
      );
    }

    return <ArticlePreview article={privacyPolicy} embed />;
  }
}
